module.exports = __webpack_public_path__ + "static/media/F8.6185598f.jpg";